var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isPng
    ? _c("v-img", {
        attrs: { width: 40, height: 40, src: "/images/fileicon/png.png" },
      })
    : _vm.isImage
    ? _c("v-img", {
        attrs: { width: 40, height: 40, src: "/images/fileicon/image.png" },
      })
    : _vm.isZip
    ? _c("v-img", {
        attrs: { width: 40, height: 40, src: "/images/fileicon/zip.png" },
      })
    : _c("v-img", {
        attrs: { width: 40, height: 40, src: "/images/fileicon/documents.png" },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }